import React from "react";
import SettingsLayer from "../../components/Settings/SettingsLayer";
import Breadcrumb from "../../components/Breadcrumb";
import MasterLayout from "../../masterLayout/MasterLayout";



const SettingsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Settings" />

        {/* SettingsLayer */}
        <SettingsLayer />


      </MasterLayout>
    </>
  );
};

export default SettingsPage;
